import { HomeWorkOutlined } from "@mui/icons-material";
import { isEmpty } from "lodash";
import { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import EmptyStatePlaceholder from "../../../../components/feedback/EmptyStatePlaceholder";
import TableClickthroughSection from "../../shared/TableClickthroughSection";
import LoanDrilldownTabPanel from "../LoanDrilldownTabPanel";
import AppraisalPreviewCard from "./AppraisalPreviewCard";
import LoanAppraisalsTable from "./LoanAppraisalsTable";

const LoanDrilldownAppraisalsTab = ({ value, tab }) => {
  const [selected, setSelected] = useState(null);
  const ref = useRef();
  const [quickFilter, setQuickFilter] = useState(null);
  const appraisals = useSelector(
    (state) => state?.loanDrilldown?.appraisals || []
  );

  const handleOnRowClicked = useCallback(
    (d) => {
      setSelected(d);
    },
    [setSelected]
  );

  const handleCloseDrilldown = useCallback(() => {
    setSelected(null);
  }, []);

  useEffect(() => {
    if (selected) {
      setSelected(null);
    }
  }, [selected]);

  if (isEmpty(appraisals)) {
    return (
      <LoanDrilldownTabPanel value={value} tab={tab}>
        <EmptyStatePlaceholder
          icon={<HomeWorkOutlined />}
          title="No appraisals on this loan"
          description="Appraisals will appear here once they've been ordered and returned for this loan's subject properties."
        />
      </LoanDrilldownTabPanel>
    );
  }

  return (
    <LoanDrilldownTabPanel value={value} tab={tab}>
      <TableClickthroughSection
        title={"Appraisals"}
        quickFilter={quickFilter}
        setQuickFilter={setQuickFilter}
      >
        <LoanAppraisalsTable
          rowData={appraisals}
          ref={ref}
          onRowClicked={handleOnRowClicked}
          selected={selected}
          quickFilterText={quickFilter}
        />
      </TableClickthroughSection>
      <AppraisalPreviewCard
        selected={selected}
        onClose={handleCloseDrilldown}
      />
    </LoanDrilldownTabPanel>
  );
};

export default LoanDrilldownAppraisalsTab;
